import { render } from "./SiteFooterPlainNavigationSection.vue?vue&type=template&id=65bc2802&scoped=true"
import script from "./SiteFooterPlainNavigationSection.vue?vue&type=script&lang=js"
export * from "./SiteFooterPlainNavigationSection.vue?vue&type=script&lang=js"

import "./SiteFooterPlainNavigationSection.vue?vue&type=style&index=0&id=65bc2802&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65bc2802"]])

export default __exports__